<template>
  <ul class="menu-nav">
    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{
        'menu-item-open': hasActiveChildren(item.route),
      }"
      v-for="(item, index) in itemsMenu"
      :key="index"
    >
      <router-link
        :to="item.route"
        v-slot="{ href, navigate }"
        v-if="!item.subItems"
      >
        <a 
        
        :href="href" class="menu-link menu-toggle" @click="navigate">
          <i
            class="text-white menu-icon"
            :class="{ [item.iconClass]: true }"
          ></i>
          <span class="menu-text text-uppercase text-white">{{
            item.title
          }}</span>
        </a>
      </router-link>

      <a href="#" class="menu-link menu-toggle" v-if="item.subItems">
        <i class="text-white menu-icon" :class="{ [item.iconClass]: true }"></i>
        <span class="menu-text text-uppercase text-white">
          {{ item.title }}
        </span>
        <i class="text-white menu-arrow"></i>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-right">
        <ul class="menu-subnav">
          <router-link
            :to="subItem.route"
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-for="(subItem, index) in item.subItems"
            :key="index"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
        

              <a
                v-show="lista_permissoes_filial.ra_Empresa"
                v-if="subItem.permissao == 'ra_Empresa'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a>

               <a
                v-show="lista_permissoes_filial.ra_Role"
                v-if="subItem.permissao == 'ra_Role'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 

              <a
                v-show="lista_permissoes_filial.ra_Sala"
                v-if="subItem.permissao == 'ra_Sala'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a>
              <a
                v-show="lista_permissoes_filial.ra_Disciplina"
                v-if="subItem.permissao == 'ra_Disciplina'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a>
              <a
                v-show="lista_permissoes_filial.ra_Filial"
                v-if="subItem.permissao == 'ra_Filial'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a>
            
              <a
                v-show="lista_permissoes_filial.ra_Local"
                v-if="subItem.permissao == 'ra_Local'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a>

              <a
                v-show="lista_permissoes_filial.ra_Perfil"
                v-if="subItem.permissao == 'ra_Perfil'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a>
              <a
                v-show="lista_permissoes_filial.ra_Setor"
                v-if="subItem.permissao == 'ra_Setor'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a>

                  <a
                v-show="lista_permissoes_filial.ra_CategoriaProduto"
                v-if="subItem.permissao == 'ra_CategoriaProduto'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a>
            
          
              <a
                v-show="lista_permissoes_filial.ra_Fornecedor"
                v-if="subItem.permissao == 'ra_Fornecedor'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a>
              <a
                v-show="lista_permissoes_filial.ra_Produto"
                v-if="subItem.permissao == 'ra_Produto'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a>
              <a
                v-show="lista_permissoes_filial.ra_FinanModoPagamento"
                v-if="subItem.permissao == 'ra_FinanModoPagamento'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a>
              <a
                v-show="lista_permissoes_filial.ra_FinanCambio"
                v-if="subItem.permissao == 'ra_FinanCambio'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 

                 <a
                v-show="lista_permissoes_filial.ra_FinanCaixa"
                v-if="subItem.permissao == 'ra_FinanCaixa'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 
                  <a
                v-show="lista_permissoes_filial.ra_FinanDepartamento"
                v-if="subItem.permissao == 'ra_FinanDepartamento'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 


             <a
                v-show="lista_permissoes_filial.ra_FinanOrcamentoAnual"
                v-if="subItem.permissao == 'ra_FinanOrcamentoAnual'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 

               <a
                v-show="lista_permissoes_filial.ra_FinanCentroCusto"
                v-if="subItem.permissao == 'ra_FinanCentroCusto'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 
                <a
                v-show="lista_permissoes_filial.ra_FinanCentroCustoDepartamento"
                v-if="subItem.permissao == 'ra_FinanCentroCustoDepartamento'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a>

                   <a
                v-show="lista_permissoes_filial.ra_FinanAprovacao"
                v-if="subItem.permissao == 'ra_FinanAprovacao'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 
              
                  <a
                v-show="lista_permissoes_filial.ra_FinanAprovador"
                v-if="subItem.permissao == 'ra_FinanAprovador'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 
              
            
              <a
                v-show="lista_permissoes_filial.ra_Banco"
                v-if="subItem.permissao == 'ra_Banco'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 

                <a
                v-show="lista_permissoes_filial.ra_FinanFormaPagamento"
                v-if="subItem.permissao == 'ra_FinanFormaPagamento'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 
              
                  <a
                v-show="lista_permissoes_filial.ra_ContratoAluno"
                v-if="subItem.permissao == 'ra_ContratoAluno'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 

                  <a
                v-show="lista_permissoes_filial.ra_Turma"
                v-if="subItem.permissao == 'ra_Turma'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 


                <a
                v-show="lista_permissoes_filial.ra_OfertaDisciplinaTurma"
                v-if="subItem.permissao == 'ra_OfertaDisciplinaTurma'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 
                <a
                v-show="lista_permissoes_filial.ra_SemestreOfertaDisciplina"
                v-if="subItem.permissao == 'ra_SemestreOfertaDisciplina'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 
                <a
                v-show="lista_permissoes_filial.ra_GradeCurricular"
                v-if="subItem.permissao == 'ra_GradeCurricular'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 
                <a
                v-show="lista_permissoes_filial.ra_DisciplinaGradeCurricular"
                v-if="subItem.permissao == 'ra_DisciplinaGradeCurricular'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 

                   <a
                v-show="lista_permissoes_filial.ra_Tipo_Grade_Curricular"
                v-if="subItem.permissao == 'ra_Tipo_Grade_Curricular'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 

                 <a
                v-show="lista_permissoes_filial.ra_Curso"
                v-if="subItem.permissao == 'ra_Curso'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 

                 <a
                v-show="lista_permissoes_filial.ra_Semestre"
                v-if="subItem.permissao == 'ra_Semestre'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 

                     <a
                v-show="lista_permissoes_filial.ra_SemestreAnual"
                v-if="subItem.permissao == 'ra_SemestreAnual'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 

                   <a
                v-show="lista_permissoes_filial.ra_SemestreLetivo"
                v-if="subItem.permissao == 'ra_SemestreLetivo'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 

                   <a
                v-show="lista_permissoes_filial.ra_Ano"
                v-if="subItem.permissao == 'ra_Ano'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 

             <a
                v-show="lista_permissoes_filial.ra_Usuario"
                v-if="subItem.permissao == 'ra_Usuario'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 
               <a
                v-show="lista_permissoes_filial.ra_Atendimento"
                v-if="subItem.permissao == 'ra_Atendimento'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 

          <a
                v-show="lista_permissoes_filial.ra_TipoProduto"
                v-if="subItem.permissao == 'ra_TipoProduto'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 
                    <a
                v-show="lista_permissoes_filial.ra_Substancias"
                v-if="subItem.permissao == 'ra_Substancias'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 
                <a
                v-show="lista_permissoes_filial.ra_Laboratorio"
                v-if="subItem.permissao == 'ra_Laboratorio'"
                :href="href"
                class="menu-link"
                @click="navigate"
              >
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> 
              <!-- <a v-if="lista_permissoes_filial.ra_Role == subItem.permissao"
                       :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a>
                <a v-if="lista_permissoes_filial.ra_Sala == subItem.permissao"
                       :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> {{ subItem.title }} </span>
              </a> -->
            </li>
          </router-link>
        </ul>
      </div>
    </li>

    <li class="menu-section d-none">
      <h4 class="menu-text">Componentss</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>
  </ul>
</template>

<script>
import sideMenu from "@/core/router/sideMenu";

export default {
  name: "KTMenu",

  data() {
    return {
      itemsMenu: sideMenu,
      sede_id: "0",
    };
  },
  created() {
    this.$store.dispatch("sistema/listar_filiais_autorizadas");
  },
  watch: {
    sede_id: function () {
      this.$store.dispatch("vincularSede", this.sede_id);
    },
  },
  computed: {
    lista_permissoes_filial() {
      return this.$store.state.sistema.lista_permissoes_filial;
    },
    lista_filiais_autorizadas() {
      return this.$store.state.sistema.lista_filiais_autorizadas;
    },
  },
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    },
  },
};
</script>
